import {Chip} from "@mui/material";
import React from "react";

interface CustomChipProps {
    text: string;
    variant: string; // primary or secondary
}

export const CustomChip: React.FC<CustomChipProps> = ({text, variant}) => {
    const backgroundColor = variant === 'primary' ? 'rgba(6, 156, 63, 0.15)' : 'rgba(255, 165, 0, 0.15)'

    return (
        <Chip label={text} size="medium" sx={{
            backgroundColor: {backgroundColor},
            color: `${variant}.light`,
            fontSize: '1.2rem',
            height: 48,
            padding: '0 10px',
        }}/>
    )
}